var DEFAULT_STRINGS = {
    warningHeader: '¿Desea continuar su sesión?',
    warningBody: 'Por razones de seguridad, su sesión expirará a menos que elija continuar.',
    warningButton: 'Continuar Sesión',
    sessionHeader: 'Su sesión ha expirado.',
    sessionBody: 'Debido a razones de seguridad, su sesión ha expirado.',
    sessionButton: 'Aceptar'
};
export default DEFAULT_STRINGS;
